module.exports = __webpack_public_path__ + "static/media/FFEP_221125.9d49540f.jpg";